import { Environment } from '../../config/environment';
import { StreamType } from '../../api/models/Shared.types';

export class BlackoutUtil {
  private static cache: Map<string, Map<StreamType, string>>;

  static create(streamType: StreamType | undefined): string | undefined {
    if (!streamType) return undefined;
    if (!this.cache) this.cache = new Map();

    let platformCache = this.cache.get(Environment.system);
    if (!platformCache) {
      platformCache = new Map();
      this.cache.set(Environment.system, platformCache);
    }

    let result = platformCache.get(streamType);
    if (!result) {
      result = `${Environment.system}.${streamType}`;
      platformCache.set(streamType, result);
    }

    return result;
  }
}
